import { images } from "../../assets/Images/assetsImages"

const GallerySection = () => {
    return (
        <section className='w-full'>
            <div className="w-full py-[80px] bg-[#E6F3CD] bg-opacity-60">
                <div className="w-full flex flex-col md:flex-row space-y-10 items-center justify-center">
                    <div className="w-[300px] h-[320px] rounded-tr-[100px] rounded-bl-[100px] mx-[20px] lg:mx-[60px] xl:mx-[80px] flex items-end justify-center cursor-pointer"
                        style={{
                            backgroundImage: `url(${images.GalleryCategoryFood})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        }}>
                        <div className="w-full h-[30%] rounded-bl-[100px] bg-[#F5E9D7] bg-opacity-80 flex items-center justify-center">
                            <h1 className="font-semibold font-playfair text-[30px] text-[#41220E]">Food</h1>
                        </div>
                    </div>
                    <div className="w-[300px] h-[320px] rounded-tr-[100px] rounded-bl-[100px] mx-[20px] lg:mx-[60px] xl:mx-[80px] flex items-end justify-center cursor-pointer"
                        style={{
                            backgroundImage: `url(${images.GalleryCategoryTeam})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        }}>
                        <div className="w-full h-[30%] rounded-bl-[100px] bg-[#F5E9D7] bg-opacity-80 flex items-center justify-center">
                            <h1 className="font-semibold font-playfair text-[30px] text-[#41220E]">Team</h1>
                        </div>
                    </div>
                    <div className="w-[300px] h-[320px] rounded-tr-[100px] rounded-bl-[100px] mx-[20px] lg:mx-[60px] xl:mx-[80px] flex items-end justify-center cursor-pointer"
                        style={{
                            backgroundImage: `url(${images.GalleryCategoryInterior})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        }}>
                        <div className="w-full h-[30%] rounded-bl-[100px] bg-[#F5E9D7] bg-opacity-80 flex items-center justify-center">
                            <h1 className="font-semibold font-playfair text-[30px] text-[#41220E]">Interior</h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default GallerySection
